import { render, staticRenderFns } from "./PlayControl.vue?vue&type=template&id=a895ca06&scoped=true&"
import script from "./PlayControl.vue?vue&type=script&lang=js&"
export * from "./PlayControl.vue?vue&type=script&lang=js&"
import style0 from "./PlayControl.vue?vue&type=style&index=0&id=a895ca06&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a895ca06",
  null
  
)

export default component.exports